import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import AboutHeader from "./sections/AboutHeader";
import CompanyOverview from "./sections/CompanyOverview";
import ProductRange from "./sections/ProductRange";
import IndustriesPartnerships from "./sections/IndustriesPartnerships";
import ValueAddedServices from "./sections/ValueAddedServices";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <AboutHeader />
      <CompanyOverview />
      <ProductRange />
      <IndustriesPartnerships />
      <ValueAddedServices />
      <Footer />
    </div>;
}